import {
  Text,
  Card,
  Box,
  Stack,
  Badge,
  Column,
  Columns,
  Heading,
  IconInfo,
  Strong,
  ButtonLink,
  Inline,
  TooltipRenderer,
} from 'braid-design-system';

import { useListingUpgradeItems } from '../hooks/useListingUpgradeItems';

import * as styles from './ListingUpgradeContactItems.css';

export const ListingUpgradeContactItems = () => {
  const listingUpgradeItems = useListingUpgradeItems();

  return (
    <Columns space="medium" collapseBelow="tablet">
      {listingUpgradeItems.map((item) => (
        <Column key={item.heading}>
          <Box>
            <Card>
              <Stack space="medium">
                <Stack space="small">
                  <Box
                    className={
                      item.badgeType
                        ? styles.visibleBadgeSlot
                        : styles.placeholderBadgeSlot
                    }
                  >
                    {item.badgeType ? (
                      <Badge tone="promote">{item.badgeType}</Badge>
                    ) : null}
                  </Box>
                  <Heading level="4">{item.heading}</Heading>
                  <Text>{item.description}</Text>
                </Stack>

                <Stack space="small">
                  <Heading level="3" weight="weak">
                    {item.price}
                  </Heading>
                  <Text tone="secondary">+ GST</Text>
                </Stack>

                <Stack space="small">
                  <Inline space="xsmall" alignY="center">
                    <Text>Estimated performance</Text>
                    <TooltipRenderer
                      tooltip={
                        <Text size="small">
                          Based on the average performance of SEEK Business
                          listings. Individual results may differ based on
                          industry and location.
                        </Text>
                      }
                    >
                      {({ triggerProps }) => (
                        <Box {...triggerProps}>
                          <IconInfo size="fill" />
                        </Box>
                      )}
                    </TooltipRenderer>
                  </Inline>
                  <Text>
                    <Strong>{item.performance}</Strong> <Strong>views</Strong>
                  </Text>
                </Stack>

                <ButtonLink
                  variant="ghost"
                  tone="formAccent"
                  href={item.contactUsLink}
                >
                  Contact us
                </ButtonLink>
              </Stack>
            </Card>
          </Box>
        </Column>
      ))}
    </Columns>
  );
};
